import React from 'react'

const AuthConectSolarLogo = () => (
  <div className="auth-brand">
    <div className="auth-brand-row">
      <svg className="auth-sun-icon" width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
        <circle cx="12" cy="12" r="5" fill="#FACC15" />
        <path
          d="M12 2V4M12 20V22M4 12H2M22 12H20M19.07 4.93L17.66 6.34M6.34 17.66L4.93 19.07M19.07 19.07L17.66 17.66M6.34 6.34L4.93 4.93"
          stroke="#FACC15"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
      <h1 className="auth-brand-title">
        Conect<span className="auth-brand-accent">Solar</span>
      </h1>
    </div>
  </div>
)

export default AuthConectSolarLogo
